module.exports = __webpack_public_path__ + "static/media/jetsuitex.57fea7a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/video/jetsuitex.jpg
// module id = 502
// module chunks = 0